export default {
  EMP_TABLE_COLUMS: [
    { Header: 'Project', accessor: 'Project' },
    { Header: 'Activity Type', accessor: 'Activity Type' },
    { Header: 'Work Description', accessor: 'Work Description' },
    { Header: 'Duration', accessor: 'Duration' }
  ],
  AUTHETICATE_TYPE: {
    BASIC: 'Basic',
    BEARER: 'Bearer'
  },
  BUZZ_TYPES: [
    { value: 'rewards', label: 'Rewards' },
    { value: 'home', label: 'Home' },
    { value: 'blogs', label: 'Blogs' }
  ],
  TYPE_VALUE: [
    { value: 'Image', label: 'Image' },
    { value: 'Video', label: 'Video' },
  ],
  LOGOUT_TXT: 'Logout',
  LOGIN_TXT: 'Welcome!',
  LOGIN_PARA_TXT: 'Begin by logging in with your Techpearl email address below.',
  GOOGLE_LOGIN_TXT: 'Continue with Google',
  CONTACT_ADMIN: 'Contact ADMIN',
  ORGANISATION_ID: 'techpearl',
  MAIL_LINK: `https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=${encodeURIComponent('vishnu.kg@techpearl.com')}&su=${encodeURIComponent('Work Management Dashboard request')}&body=${encodeURIComponent('Hi,\nPlease enable the work management dashboard')}`,
  EMPLOYEE_TYPES: {
    'EMPLOYEE': 'EMPLOYEE',
    'TEAM_LEAD': 'TEAM_LEAD',
    'PROJECT_MANAGER': 'PROJECT_MANAGER',
    'ADMIN': 'ADMIN',
  },
  MAIN_NAV_ITEMS: {
    WORK_LOG: 'Work Log',
    EMPLOYEES: 'Employees',
    PROJECTS: 'Projects',
    EXCEPTION_REPORTS: 'Exception Report',
    MONTHLY_REPORT: 'Monthly Report',
    MY_TEAM: 'My Team',
    MY_GOALS: 'My Goals',
    TEAM_GOALS: 'Team Goals'
  },
  DASHBOARD_NOT_READY: 'Your dashboard is not ready! Please contact the admin.',
  REPORT_TABLE_COLUMN_DEFS: ['Project', 'Date', 'Activity', 'Work Description', 'Duration', 'Comments', 'Actions'],
  DESIGNATIONS: ['Intern Software Developer', 'Junior Software Engineer', 'Software Engineer', 'Senior Software Engineer', 'Principal Software Engineer', 'Technical Lead', 'Manager', 'Software Architect', 'Chief Architect', 'Director of Engineering', 'VP of Marketing', 'Product Manager', 'Senior Website Developer & SEO Specialist', 'Office Manager', 'Business Development Manager', 'Vice President', 'CIO', 'CTO', 'CEO'],
  EMPLOYEE_TYPE_LIST: ['ADMIN', 'TEAM_LEAD', 'EMPLOYEE', 'PROJECT_MANAGER'],
  ADMIN_TYPE_LIST: ['ADMIN', 'PROJECT_MANAGER', 'TEAM_LEAD'],
  ERROR_MSG: 'Something went wrong, Data Not saved!',
  DELETE_MSG: 'Something went wrong',
  ERROR: 'Something went wrong, Could Not Fetch',
  ERROR_EXCEPTION_EMAIL_MSG: 'Unable to Send Email!',
  SUCCESS_MSG: 'Success! Your data has been saved successfully.',
  SUCCESS: 'Success!',
  FAILED: 'Something went wrong',
  DATE_FORMAT: 'DD-MMM-YYYY',
  EXCEL_FILE_NAME: 'exceptionreport',
  EXCEL_MONTHLY_FILE_NAME: 'monthlyreport',
  EXCEL_EXPORT_TYPE: 'xls',
  MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  START_YEAR: 2023,
  STAFF: 'staff',
  REWARDS: 'rewards',
  BLOGS: 'blogs',
  IMAGE: 'Image',
  TEAM: 'Team',
  TEAM_REPORT_HEADERS: ['Employee Name', 'Date', 'Feature', 'Category', 'Work Item', 'Duration', 'Work Mode'],
  QUOTES: [
    {
      'author': 'Matt Mullenweg',
      'content': 'Technology is best when it brings people together.'
    },
    {
      'author': 'Albert Einstein',
      'content': 'It has become appallingly obvious that our technology has exceeded our humanity.'
    },
    {
      'author': 'Edward Teller',
      'content': 'The science of today is the technology of tomorrow.'
    },
    {
      'author': 'Christian Lous Lange',
      'content': 'Technology is a useful servant but a dangerous master.'
    },
    {
      'author': 'Libby Larsen',
      'content': 'The great myth of our times is that technology is communication.'
    },
    {
      'author': 'Arthur C. Clarke',
      'content': 'Any sufficiently advanced technology is indistinguishable from magic.'
    },
    {
      'author': 'B. F. Skinner',
      'content': 'The real problem is not whether machines think but whether men do.'
    },
    {
      'author': 'Bill Gates',
      'content': 'Technology is just a tool. In terms of getting the kids working together and motivating them, the teacher is the most important.'
    },
    {
      'author': 'Bill Gates',
      'content': 'The advance of technology is based on making it fit in so that you don\'t really even notice it, so it\'s part of everyday life.'
    },
    {
      'author': 'Marshall McLuhan',
      'content': 'As technology advances, it reverses the characteristics of every situation again and again. The age of automation is going to be the age of \'do it yourself.\''
    }
  ],
  LOCAL_STORAGE_KEYS: {
    ADMIN_REPORT: 'ADMIN_REPORT',

  }
} as const;

export const SIGNIN_EXCEPTIONS = {
  USER_NOT_CONFIRMED_EXCEPTION: 'UserNotConfirmedException',
  PASSWORD_RESET_REQUIRED_EXCEPTION: 'PasswordResetRequiredException',
  NOT_AUTHORIZED_EXCEPTION: 'NotAuthorizedException',
  USER_NOT_FOUND_EXCEPTION: 'UserNotFoundException'
};
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  INSTRUCTIONS: '/instructions',
  CHECKLIST: '/checklist',
  COMINGSOON: '/ComingSoon',
  DAILYREPORT: '/dailyReport',
  EMPLOYEE: '/manageEmployee',
  PROJECTS: '/manageProjects',
  SUMMARY: '/workItemSummary',
  MONTHLYREPORT: '/monthlyreport',
  TEAMS: '/myteam',
  REWARDS: '/rewards',
  STAFF: '/staff',
  BLOGS: '/blogs',
  TEAM_GOALS: '/teamgoals',
  MYGOALS: '/mygoals',
};

export const HUB_EVENTS = {
  COGNITO_HOSTED_UI: 'cognitoHostedUI',
  SIGNED_IN: 'signedIn'
};

export const USER_AVATAR_TOOLTIP = 'Open settings';
export const NOTIFICATION_TOOLTIP = 'Show Notifications';

export const REPORT_TABLE = {
  NO_REPORTS_TXT: 'No records',
  PROJECT_FIELDS: {
    PROJECT_NAME: { name: 'projectName', header: 'Project' },
    FEATURE: { name: 'feature', header: 'Feature' },
    ACTIVITY_DATE: { name: 'activityDate', header: 'Date' },
    ACTIVITY_TYPE: { name: 'activityType', header: 'Category' },
    WORK_DESCRIPTION: { name: 'workDescription', header: 'Work Description' },
    ACTIVITY_DURATION: { name: 'activityDuration', header: 'Duration' },
		WORK_MODE: { name: 'workMode', header: 'Work Mode' },
    COMMENTS: { name: 'comments', header: 'Comments' },
  },
  PAGE_SIZE: 100,
  ACTIVITIES: ['Account Based Marketing (ABM)', 'Bug', 'Code Review and PR', 'Customer communication', 'Dev', 'Deployment', 'Email marketing', 'Escalation', 'Folder update', 'Holiday', 'Interview', 'Leave', 'Linked In', 'Management', 'Misc. ADMIN and HR work', 'New Joinee process', 'Others', 'Re-work', 'Team Meeting', 'Testing', 'Upwork', 'Work review'],
  WORK_MODE_OPTIONS: ['Office', 'Home', 'Client Location'],
  HELP_TEXT: ['1. Double click the row to edit', '2. Only Last one week data is editable'],
  ACTIVITY_DURATION_VALUES: { MIN: '0.25', MAX: '8', STEP: '0.25' }
};

export const MY_TEAM_DOWNLOAD_TITLES = {
  TEAM_REPORT_EXPORT: 'Team Report Export',
  TIMELINE_REPORT_EXPORT: 'Timeline Export',
  FEATURE_REPORT_EXPORT: 'Feature Export'
};

export const PROJECT_MEMBERS_DROPDOWN = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    }
  }
};

export const PROJECTS_DROPDOWN = {
  PaperProps: {
    style: {
      maxHeight: 300, 
      width: 250,
    },
  },
  MenuListProps: {
    dense: true,
  },
};

export const WORK_MODE_VALUE_MAP = REPORT_TABLE?.WORK_MODE_OPTIONS.reduce((acc, mode) => {
  acc[mode] = mode;
  return acc;
}, {} as Record<string, string>);

export const exceptionActivityTypes = [ 'Leave', 'Holiday' ];

export const ALLOWED_KEYS = [
  'goalId',
  'organisationId',
  'userName',
  'employeeType',
  'leadId',
  'goalStartDate',
  'goalEndDate',
  'goals',
];


